import { SET_UNSAVED_CHANGES, UPDATE_STATE } from "../types";
import grouping from '../../constants/grouping/amendment-grouping.json'

const getAmendmentElements = () => {
    let itemElements = [];
    let headerElements = [];

    const levels = ['item', 'header']

    levels.forEach(level => {
        grouping[level].forEach(tab => {
            tab.sections.forEach(section => {

                section.elements?.forEach(element => {
                    if (level === 'item') {
                        itemElements.push(element.elementName);
                    } else {
                        headerElements.push(element.elementName);
                    };
                });
            });
        });
    });

    return { headerElements, itemElements };
}

export const createAmendmentUtil = (state, dispatch) => {
    if (state.declaration.amendment) {
        return;
    };

    const { headerElements, itemElements } = getAmendmentElements()
    let amendment = { declarationItems: [] };

    headerElements.forEach(element => {
        amendment[element] = state.declaration[element]
    });

    state.declaration.declarationItems?.forEach((item, index) => {
        itemElements.forEach(element => {
            amendment.declarationItems[index] = {
                ...amendment.declarationItems[index],
                name: item.name,
                [element]: item[element]
            }
        })
    })

    state.declaration.amendment = amendment;
    dispatch({
        type: UPDATE_STATE,
        payload: {declaration: state.declaration}

    });

    dispatch({
        type: SET_UNSAVED_CHANGES,
        payload: true
    })
};

export const cancelAmendmentUtil = (state, dispatch) => {
    delete state.declaration.amendment;

    dispatch({
        type: UPDATE_STATE,
        payload: {declaration: state.declaration}
    })
};